<template>
    <div color="grey lighten-4">
        <v-img :max-height="height ? height : null" :max-width="width ? width  : null" :aspect-ratio="aspectRatio" @click="showMediaLibary" v-if="showImage" :src="image"></v-img>
        <p>
            For best results upload an SVG or png in horizontal format. A good rule of thumb is 300 x 60 pixels. It will be automatically resized to fit in the available space. 
        </p>
        <v-btn v-model="image" color="secondary" depressed @click="showMediaLibary">Click to Add Logo</v-btn>
    </div>
</template>
<script>
import { EventBus } from '@/event-bus';

export default {
    props: ['value', 'label', 'showImage', 'aspectRatio', 'height', 'width'],

    data() {
        return {
            image: this.value
        }
    },
    methods: {
        showMediaLibary: function() {
            EventBus.$emit("medialibrary", this.useImage)
            this.$emit('showMediaLibrary', this.useImage)
        },
        useImage: function(file) {
            this.image = file;
            this.$emit("input", file);
        },
    },
    watch: {
        'image': function(newValue) {
            this.$emit("input", newValue);
        }
    }
}
</script>
